// extracted by css-extract-rspack-plugin
export default {"cls1":"SavedReferencesList-cls1_Omy","cls2":"SavedReferencesList-cls2_mjh SavedReferencesList-cls1_Omy"};